import React, { useEffect, useState } from "react";

import {
  Head,
  Card,
} from "../../../components/template";

import {
  getRetreatTypes,
} from "../../../services/retreatTypeService";
const Retreats = () => {
const [retreats, setRetreats] = useState([]);

useEffect(() => {
  loadRetreatTypes();
}, []);

const loadRetreatTypes = async () => {
  try {
    const res = await getRetreatTypes();

    const data = res.data.map((item) => ({
      title: item.typeName,
      tagline: item.heroSubtitle,
      bestFor: item.experienceHighlights?.join(" • "),
      gain: item.heroDescription,
      image:
        item.heroImage ||
        "/assets/innergise/cardi.JPG",
      link: `/${item.route}`,
    }));

    setRetreats(data);
  } catch (err) {
    console.error(err);
  }
};


  return (
    <main className="bg-[#F7F1EA] min-h-screen">

      {/* ================================================= */}
      {/* HERO */}
      {/* ================================================= */}

      <section className="pt-14 pb-10 px-6">

        <div className="max-w-[1400px] mx-auto">

          <div
            className="
              text-center
              max-w-[980px]
              mx-auto
              mb-16
            "
          >

            {/* LABEL */}
            <div
              className="
                inline-flex
                items-center
                px-5
                py-2
                rounded-full
                bg-[#FFF4E8]
                border
                border-[#F3DDC7]
                text-[#C26B2E]
                text-[11px]
                tracking-[.18em]
                uppercase
                font-medium
                mb-6
              "
            >
              Param Retreats
            </div>

            {/* HEADING */}
            <h1
              className="
                text-[clamp(52px,7vw,96px)]
                leading-[.95]
                tracking-[-0.05em]
                text-secondary
                mb-8
              "
            >
              Transformative
              <br />
              Retreats
            </h1>

            {/* DESCRIPTION */}
            <p
              className="
                text-[#5F5751]
                text-[17px]
                md:text-[18px]
                leading-9
                max-w-[760px]
                mx-auto
              "
            >
              Disconnect from chaos. Recharge
              your energy, regain clarity,
              strengthen emotional wellbeing,
              and reconnect with your deepest
              self through immersive wellness
              experiences.
            </p>
          </div>

          {/* GRID */}
          <div
            className="
              grid
              grid-cols-1
              md:grid-cols-2
              xl:grid-cols-3
              gap-8
            "
          >
            {retreats.map((retreat, index) => (
              <Card
                key={index}
                {...retreat}
              />
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Retreats;
